<div class="reports-container">
  <div class="reports-topbar">
    <div class="topbar-left">
      <h1>
        Stock Movement
        <small>Incoming and outgoing over the selected period</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i>
        <a routerLink="/reports">IMS / Reports</a> /
        <span class="current">Stock Movement</span>
      </div>
    </div>
    <div class="topbar-right">
      <app-report-date-range />
      <a routerLink="/reports" class="btn btn-outline btn-sm">
        <i class="bi bi-arrow-left"></i> Back to Reports
      </a>
      <button class="btn btn-primary" (click)="exportData()"><i class="bi bi-download"></i> Export</button>
    </div>
  </div>

  <div class="report-period">
    <i class="bi bi-calendar3"></i>
    <span>Showing data for {{ dateRange.appliedLabel() }}</span>
  </div>

  <div class="report-card">
    <div class="report-header">
      <div class="report-title">
        <i class="bi bi-arrow-left-right" style="color:#4f6ef7;"></i>
        <h2>Stock Movement</h2>
        <span class="report-badge">{{ dateRange.appliedDayCount() }} days</span>
      </div>
    </div>
    <div class="report-body">
      <div class="movement-stats">
        <div class="movement-item">
          <span class="movement-label">Incoming</span>
          <span class="movement-value green">+{{ movementStats().incoming }}</span>
        </div>
        <div class="movement-item">
          <span class="movement-label">Outgoing</span>
          <span class="movement-value red">-{{ movementStats().outgoing }}</span>
        </div>
        <div class="movement-item">
          <span class="movement-label">Net Change</span>
          <span class="movement-value blue">{{ movementStats().net >= 0 ? '+' : '' }}{{ movementStats().net }}</span>
        </div>
      </div>
      <div class="mini-sparkline">
        @for (movement of movements().slice(0, 12); track movement.id) {
          <div class="sparkline-bar" [style.height.px]="sparkHeight(movement.quantity)"></div>
        }
      </div>
      <div class="movement-list">
        @for (movement of movements(); track movement.id) {
          <div class="checked-item">
            <span class="asset-name">{{ movement.itemName }}</span>
            <span class="asset-funeral">{{ movement.movementType | titlecase }}</span>
            <span class="asset-due">{{ formatDate(movement.date) }} · {{ movement.reference }}</span>
          </div>
        } @empty {
          <p class="report-empty">No stock movements for this period.</p>
        }
      </div>
      <div class="report-footer">
        <span>{{ movements().length }} movements for {{ dateRange.appliedLabel() }}</span>
      </div>
    </div>
  </div>
</div>
